import React from 'react';
import { Modal, Button } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import './Modal.scss';

const CustomModal = ({
  visible,
  onClose,
  onPrimaryAction,
  onSecondaryAction,
  primaryButtonText = 'OK',
  secondaryButtonText = 'Cancel',
  title,
  description,
  status, // 'success' or 'error'
  showPrimaryButton = true,
  showSecondaryButton = true,
  primaryButtonProps = {},
  secondaryButtonProps = {},
  ...modalProps
}) => {
  const getStatusIcon = () => {
    if (status === 'success') {
      return <CheckCircleOutlined className="modal-status-icon success" />;
    }
    if (status === 'error') {
      return <CloseCircleOutlined className="modal-status-icon error" />;
    }
    return null;
  };

  const footer = (
    <div className="modal-footer">
      {showSecondaryButton && (
        <Button
          onClick={onSecondaryAction || onClose}
          {...secondaryButtonProps}
        >
          {secondaryButtonText}
        </Button>
      )}
      {showPrimaryButton && (
        <Button
          type="primary"
          onClick={onPrimaryAction || onClose}
          {...primaryButtonProps}
        >
          {primaryButtonText}
        </Button>
      )}
    </div>
  );

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={footer}
      className={`custom-modal ${status ? `modal-${status}` : ''}`}
      {...modalProps}
    >
      <div className="modal-content">
        {getStatusIcon()}
        {title && <h3 className="modal-title">{title}</h3>}
        {description && <p className="modal-description">{description}</p>}
        {modalProps.children}
      </div>
    </Modal>
  );
};

export default CustomModal;